import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import type { Nullable } from 'corgi-types';

import type { RenderingType } from '../../../product-mvc-buttons/components/enums';
import type { Group } from '../../../product-mvc-buttons/components/types';
import type { SpaceProps } from '../../theme/system-types';
import { Flex } from '../Flex';
import GroupValues from './GroupValues';
import type { ChangeHandler, SelectedValue } from './types';

interface GroupsProps {
  sku: string;
  url: string;
  variationKey: Nullable<string>;
  items: Group[];
  listLength: number;
  renderingType: RenderingType;
  selectedValue: Nullable<SelectedValue>;
  onChange: ChangeHandler;
  isVariationDrawer?: boolean;
}

const Container = styled(Flex)``;
const containerStyles: ComponentProps<typeof Flex> & SpaceProps = {
  p: 'sp_16',
  flexDirection: 'column',
};

const Groups = ({
  sku,
  url,
  variationKey,
  items,
  listLength,
  renderingType,
  selectedValue,
  onChange,
  isVariationDrawer,
}: GroupsProps) => (
  <Container {...containerStyles} data-testid="group-values">
    {items.map(({ title, values, key }) => (
      <GroupValues
        key={key}
        variationKey={variationKey}
        sku={sku}
        url={url}
        items={values}
        title={title}
        listLength={listLength}
        isVariationDrawer={isVariationDrawer}
        renderingType={renderingType}
        selectedValue={selectedValue}
        onChange={onChange}
      />
    ))}
  </Container>
);

export default Groups;
